export enum CaregiverQualification {
  Type53b = '53b',
  Type53c = '53c',
  Type43b = '43b',
  Type45b = '45b',
  Type87b = '87b',
  ExperienceWithoutCertificate = 'experience_without_certificate',
  NoTraining = 'no_training',
  Searching = 'searching',
}

export const CANDIDATE_CAREGIVER_QUALIFICATIONS = [
  CaregiverQualification.Type43b,
  CaregiverQualification.Type45b,
  CaregiverQualification.Type53b,
  CaregiverQualification.Type53c,
  CaregiverQualification.Type87b,
];

export const EMPLOYER_CAREGIVER_QUALIFICATIONS = [
  ...CANDIDATE_CAREGIVER_QUALIFICATIONS,
  CaregiverQualification.ExperienceWithoutCertificate,
  CaregiverQualification.NoTraining,
];
